//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MobileBanner",
  data: function data() {
    return {
      currentIndex: 0,
      timer: null,
      touchStartX: 0,
      touchDeltaX: 0,
      isTouching: false
    };
  },
  computed: {
    currentBanner: function currentBanner() {
      return this.bannerData[this.currentIndex] || {};
    },
    cssVars: function cssVars() {
      return {
        "--mb-spacing": "16px",
        "--mb-radius": "12px",
        "--mb-radius-sm": "8px",
        "--mb-banner-height": "160px",
        "--mb-font-base": "14px",
        "--mb-font-sm": "12px",
        "--mb-font-lg": "18px",
        "--mb-primary-light": "#e8f0fe",
        "--mb-text-secondary": "#6b7280"
      };
    }
  },
  props: {
    bannerData: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {
    bannerData: {
      handler: function handler(val) {
        var _this = this;
        if (val && val.length > 1) {
          this.currentIndex = 0;
          this.$nextTick(function () {
            _this.startAutoPlay();
          });
        }
      },
      immediate: true
    }
  },
  mounted: function mounted() {
    if (this.bannerData && this.bannerData.length > 1) {
      this.startAutoPlay();
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.stopAutoPlay();
  },
  methods: {
    startAutoPlay: function startAutoPlay() {
      var _this2 = this;
      this.stopAutoPlay();
      if (!this.bannerData || this.bannerData.length <= 1) return;
      this.timer = setInterval(function () {
        if (!_this2.isTouching) {
          _this2.currentIndex = (_this2.currentIndex + 1) % _this2.bannerData.length;
        }
      }, 3000);
    },
    stopAutoPlay: function stopAutoPlay() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    onTouchStart: function onTouchStart(e) {
      this.isTouching = true;
      this.touchStartX = e.touches[0].clientX;
      this.touchDeltaX = 0;
      this.stopAutoPlay();
    },
    onTouchMove: function onTouchMove(e) {
      this.touchDeltaX = e.touches[0].clientX - this.touchStartX;
    },
    onTouchEnd: function onTouchEnd() {
      this.isTouching = false;
      var threshold = 40;
      if (Math.abs(this.touchDeltaX) > threshold) {
        if (this.touchDeltaX < 0 && this.currentIndex < this.bannerData.length - 1) {
          this.currentIndex++;
        } else if (this.touchDeltaX < 0 && this.currentIndex === this.bannerData.length - 1) {
          this.currentIndex = 0;
        } else if (this.touchDeltaX > 0 && this.currentIndex > 0) {
          this.currentIndex--;
        } else if (this.touchDeltaX > 0 && this.currentIndex === 0) {
          this.currentIndex = this.bannerData.length - 1;
        }
      }
      this.touchDeltaX = 0;
      this.startAutoPlay();
    },
    goTo: function goTo(index) {
      this.currentIndex = index;
      this.startAutoPlay();
    }
  }
};